__turbopack_context__.v({
  "bodyText": "DiscoveryCardBlock-module__BBHBrq__bodyText",
  "buttonsSection": "DiscoveryCardBlock-module__BBHBrq__buttonsSection",
  "buttonsWrapper": "DiscoveryCardBlock-module__BBHBrq__buttonsWrapper",
  "card": "DiscoveryCardBlock-module__BBHBrq__card",
  "cardBody": "DiscoveryCardBlock-module__BBHBrq__cardBody",
  "cardRow": "DiscoveryCardBlock-module__BBHBrq__cardRow",
  "mediaImage": "DiscoveryCardBlock-module__BBHBrq__mediaImage",
  "mediaSection": "DiscoveryCardBlock-module__BBHBrq__mediaSection",
  "title": "DiscoveryCardBlock-module__BBHBrq__title",
});
